import * as Constants from "./constants";

export const fieldValidationTypes = {
    Email : Constants.EMAIL,
    PhoneNumber : Constants.PHONENUMBER,
    Name : Constants.NAME,
    DocketNumber : Constants.DOCKETNUMBER,
    Notes : Constants.NOTE,
    Other : Constants.OTHER,
}